import React, { useState } from 'react';
import './ChatBotWidget.css';

async function fetchFromGroq(prompt) {
  const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer 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` 
    },
    body: JSON.stringify({
        model: 'llama-3.3-70b-versatile', 
      messages: [
        { role: 'system', content: 'You are Haute-u AR’s fashion assistant. Always respond from a fashion styling perspective, mention Haute-u AR apps, and refer users to https://apps.hauteuar.com or email info@hauteuar.com when needed.' },
        { role: 'user', content: prompt }
      ]
    })
  });

  const data = await response.json();
  return data.choices?.[0]?.message?.content || "I'm unable to help right now. Please try again or email us at info@hauteuar.com.";
}

function ChatBotWidget() {
  const isMobile = window.innerWidth <= 768;
  const [isOpen, setIsOpen] = useState(!isMobile);
  const [messages, setMessages] = useState([
    { sender: 'bot', text: '👋 Welcome to Haute-u AR! Ask me anything about fashion, styling, or our apps. You can explore all our tools at https://apps.hauteuar.com/' }
  ]);
  const [input, setInput] = useState('');

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', text: input };
    setMessages(prev => [...prev, userMessage]);

    const botText = await fetchFromGroq(input);
    setMessages(prev => [...prev, { sender: 'bot', text: botText }]);
    setInput('');
  };

  return (
    <div className="chatbot-widget">
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            Haute-u AR Assistant
            <button className="chatbot-close" onClick={() => setIsOpen(false)}>×</button>
          </div>
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.sender}`}>{msg.text}</div>
            ))}
          </div>
          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Ask me about fashion..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      )}
      {!isOpen && (
        <button className="chatbot-toggle" onClick={() => setIsOpen(true)}>
          💬
        </button>
      )}
      
    </div>
  );
}

export default ChatBotWidget;